import styled from 'styled-components';
import device from '../../mediaQueries';

export const ClearButton = styled.button.attrs({ children: '✕', type: 'button' })`
  cursor: pointer;
  &,
  & * {
    outline: none;
    border: 0;
    position: absolute;
    right: 12px;
    top: 11px;
    background: transparent;
    font-size: 13px;
  }

  ${device.mobile`
    &,
    & * {
      top: initial;
      bottom: 50px;
    }
  `}
`;
